import { applyNamedMask } from "../../utils/mask";
import { HelperCep } from "./helper-cep";
import { HelperCnpjInformaton } from "./helper-cnpj-information";
import HelperMask from "./helper-mask";
import { extractNumbers } from "./helper-string";

const setAddressFieldValues = (
  el: any,
  response: any,
  prefix: string,
): void => {
  el.setFieldValue(`${prefix}City`, response?.city ?? "");
  el.setFieldValue(`${prefix}Neighborhood`, response?.neighborhood ?? "");
  el.setFieldValue(`${prefix}Street`, response?.street ?? "");
  el.setFieldValue(`${prefix}State`, response?.state ?? "");
  el.setFieldValue(`${prefix}City`, response?.city ?? "");
  el.setFieldValue(`${prefix}Number`, "");
};

const setCompanyInformationFieldValues = (
  el: any,
  response: any
): void => {
  el.setFieldValue("socialReason", response?.razao_social ?? "");
  el.setFieldValue("fantasyName", response?.nome?.trim() || response?.razao_social || "");
  el.setFieldValue("companyEmail", response?.email ?? "");

  if (response?.telefone) {
    response.telefone.split("/").forEach((segment: string) => {
      const cleanedNumber = extractNumbers(segment);
      if (cleanedNumber.length === 10) {
        el.setFieldValue("companyPhone", applyNamedMask(cleanedNumber, "PHONE_NUMBER"));
      } else if (cleanedNumber.length === 11) {
        el.setFieldValue("companyMobilePhone", applyNamedMask(cleanedNumber, "MOBILE_NUMBER"));
      }
    });
  }

  if (response?.endereco) {
    el.setFieldValue("companyCep", response.endereco?.cep ? applyNamedMask(response.endereco.cep, "CEP") : "");
    el.setFieldValue("companyStreet", response.endereco.logradouro ?? "");
    el.setFieldValue("companyNumber", response.endereco.numero ?? "");
    el.setFieldValue("companyNeighborhood", response.endereco.bairro ?? "");
    el.setFieldValue("companyComplement", response.endereco.complemento ?? "");
    el.setFieldValue("companyCity", response.endereco.municipio ?? "");
    el.setFieldValue("companyState", response.endereco.uf ?? "");
  }

  if (response?.atividades && response.atividades.length > 0) {
    el.setFieldValue("companyActivities", response.atividades);
  }
};

export const handleCepChange = async (
  data: any,
  el: any,
  prefix: string,
): Promise<void> => {
  const cep = extractNumbers(data);
  if (HelperCep.isValidCep(cep)) {
    const response = await HelperCep.getAdressByCep(cep);
    setAddressFieldValues(el, response, prefix);
  }
};

export const handleCnpjChange = async (
  data: any,
  el: any
): Promise<void> => {
  if (data.length === 0) {
    el.setFieldValue("companyActivities", []);
  }
  const cnpj = HelperMask.removeCnpjMask(data);
  if (HelperCnpjInformaton.isValidCnpj(cnpj)) {
    const response = await HelperCnpjInformaton.getInformationCnpj(cnpj);
    setCompanyInformationFieldValues(el, response);
  }
};

export const handleNoStackChange = (
  value: any,
  el: any,
  stacks: any[],
): void => {
  const noStackDescription = "Não desejo informar";
  const noStackId = stacks.find(
    (stack) => stack.description === noStackDescription,
  )?.id;

  if (value[0] === "true" && noStackId) {
    el.setFieldValue("otherStack", "");
    el.setFieldValue("stacks", [noStackId]);
  } else if (noStackId) {
    el.setFieldValue(
      "stacks",
      el.values.stacks.filter((stackId: any) => stackId !== noStackId),
    );
  }
};

export const hasCertificate = (data: any): boolean =>
  data?.certificateFile && data?.certificatePassword && data?.certificateEmail;
